import color from "@constants/color";
import React from "react";
import { Modal, View, ActivityIndicator, StyleSheet } from "react-native";

interface Props {
  loading: boolean;
}

const LoadingModal: React.FC<Props> = ({ loading }) => {
  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={loading}
      transparent={true}
    >
      <View
        style={[styles.modaStyle, { backgroundColor: color.lightMediumBlack }]}
      >
        <ActivityIndicator size="large" color={color.primary} />
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modaStyle: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default LoadingModal;
